<div id="placeholder-paineis" (click)="fecharPaineis($event)" *ngIf="visible">
  <app-painel-comentarios
    *ngIf="painelComentariosParameters"
  ></app-painel-comentarios>
</div>
